/* eslint-disable indent */
import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';
import { TIMEZONE_VN } from 'constant';

export default function SecretarySection({ data }) {
  // #region Data
  const { t } = useTranslation();
  // #endregion Data

  return (
    <div className="flex text-lg mt-2 flex-column">
      <h4>{t('projectProposal.general.scientificSecretarySection.label')}</h4>
      <div className="flex ml-5 flex-column">
        <div className="flex flex-wrap">
          <div className="w-30rem mb-2">
            <span className="font-semibold">
              {t(
                'projectProposal.general.scientificSecretarySection.scientificSecretary.academicRank'
              )}
              :{' '}
            </span>
            <span>{data?.academicRank ? t(`academicRank.${data?.academicRank}`) : ''}</span>
          </div>
          <div className="mb-2">
            <span className="font-semibold">
              {t(
                'projectProposal.general.scientificSecretarySection.scientificSecretary.academicDegree'
              )}
              :{' '}
            </span>
            <span>{data?.academicDegree ? t(`academicDegree.${data?.academicDegree}`) : ''}</span>
          </div>
        </div>
        <div className="mb-2">
          <span className="font-semibold">
            {t('projectProposal.general.scientificSecretarySection.scientificSecretary.name')}:{' '}
          </span>
          <span>{data?.fullname}</span>
        </div>
        <div className="mb-2">
          <span className="font-semibold">
            {t('projectProposal.general.scientificSecretarySection.scientificSecretary.dob')}:{' '}
          </span>
          <span>
            {data?.dob
              ? new Date(data?.dob).toLocaleDateString('en-GB', { timeZone: TIMEZONE_VN })
              : null}
          </span>
        </div>
        <div className="flex flex-wrap">
          <div className="w-20rem mb-2">
            <span className="font-semibold">
              {t(
                'projectProposal.general.scientificSecretarySection.scientificSecretary.citizenId'
              )}
              :{' '}
            </span>
            <span>{data?.citizenId}</span>
          </div>
          <div className="w-15rem mb-2">
            <span className="font-semibold">
              {t(
                'projectProposal.general.scientificSecretarySection.scientificSecretary.dateOfIssue'
              )}
              :{' '}
            </span>
            <span>
              {data?.dateOfIssue
                ? new Date(data?.dateOfIssue).toLocaleDateString('en-GB', {
                    timeZone: TIMEZONE_VN,
                  })
                : null}
            </span>
          </div>
          <div className="w-40rem mb-2">
            <span className="font-semibold">
              {t(
                'projectProposal.general.scientificSecretarySection.scientificSecretary.placeOfIssue'
              )}
              :{' '}
            </span>
            <span>{data?.placeOfIssue}</span>
          </div>
        </div>
        <div className="mb-2">
          <span className="font-semibold">
            {t(
              'projectProposal.general.scientificSecretarySection.scientificSecretary.taxIdentificationNumber'
            )}
            :{' '}
          </span>
          <span>{data?.taxIdentificationNumber}</span>
        </div>
        <div className="flex flex-wrap">
          <div className="w-30rem mb-2">
            <span className="font-semibold">
              {t(
                'projectProposal.general.scientificSecretarySection.scientificSecretary.bankAccount'
              )}
              :{' '}
            </span>
            <span>{data?.bankAccount}</span>
          </div>
          <div className="mb-2">
            <span className="font-semibold">
              {t('projectProposal.general.scientificSecretarySection.scientificSecretary.bank')}:{' '}
            </span>
            <span>{data?.bank}</span>
          </div>
        </div>
        <div className="flex flex-wrap">
          <div className="mb-2">
            <span className="font-semibold">
              {t(
                'projectProposal.general.scientificSecretarySection.scientificSecretary.workplace'
              )}
              :{' '}
            </span>
            <span>{data?.workplace}</span>
          </div>
        </div>
        <div className="flex flex-wrap">
          <div className="w-30rem mb-2">
            <span className="font-semibold">
              {t('projectProposal.general.scientificSecretarySection.scientificSecretary.mobile')}:{' '}
            </span>
            <span>{data?.mobile}</span>
          </div>
          <div className="mb-2">
            <span className="font-semibold">Email: </span>
            <span>{data?.email}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

SecretarySection.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired,
};
